import { type FC, type ReactNode } from "react";

import { useIsDesktop } from "@application/hooks/use_is_desktop";

// The toolbar row while the assistant is open: it splits where the panes
// split. The left half is the assistant's; the right half brings its own bar
// (Search letters and Filters, or the report's file and page).
export const SplitToolbar: FC<{ left: ReactNode; right: ReactNode }> = ({
  left,
  right,
}) => (
  <div className="flex items-stretch">
    {/* 16px of padding makes this half 8px wider than the right one, so the
        halves meet where the panes below meet (across their 16px gap). */}
    <div className="relative z-30 flex min-w-0 flex-1 items-center gap-2 border-b border-slate-200 bg-white py-2.5 pl-4">
      {left}
    </div>
    <div className="relative flex min-w-0 flex-1 flex-col">{right}</div>
  </div>
);

// Under 1280 the assistant takes the full width: one row, with the
// Assistant | Letters switch at its right end. On a phone the switch leads
// the row, with the toolbar's icons at the right, and takes a row of its own
// below 375px. z-20, so it scrolls beneath the case header (z-30).
export const ToolbarRow: FC<{ children: ReactNode; trailing?: ReactNode }> = ({
  children,
  trailing,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <div className="relative z-20 flex items-center gap-2 border-b border-slate-200 bg-white px-4 py-2.5 max-md:flex-wrap">
      {!isDesktop && trailing && (
        <div className="mr-auto shrink-0 max-[374px]:basis-full">
          {trailing}
        </div>
      )}
      {children}
      {isDesktop && trailing && (
        <div className="ml-auto shrink-0">{trailing}</div>
      )}
    </div>
  );
};
